"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatError;

var _isError = _interopRequireDefault(require("./isError"));

function formatError(error) {
  if (!(0, _isError.default)(error)) return error;
  return {
    message: error.message,
    name: error.name,
    stack: error.stack
  };
}